import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HighchartsChartHost } from './highcharts-adapter';

import { EVAAIAgentComponent } from './components/ai-agent/ai-agent-bot.component';
import { ContentRendererComponent } from './components/content-renderer/content-renderer.component';
// import { GlobalSearchFiltersModule } from '../../shared-ui-refresh/global-search-filters/global-search-filters.module';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { RefreshLoaderModule } from '../loader/refresh-loader.module';
import { ChatHistoryListComponent } from './components/chat-history-list/chat-history-list.component';
import { ChipListComponent } from './components/chip-list/chip-list.component';
import { EvaChatContentComponent } from './components/eva-chat-content/eva-chat-content.component';
import { ChatFlyoutComponent } from './components/flyout/chat-flyout.component';
import { UserFeedbackComponent } from './components/user-feedback/user-feedback.component';

@NgModule({
    declarations: [
        EVAAIAgentComponent,
        ContentRendererComponent,
        ChipListComponent,
        ChatFlyoutComponent,
        UserFeedbackComponent,
        ChatHistoryListComponent,
        EvaChatContentComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        // GlobalSearchFiltersModule,
        RefreshLoaderModule,
        HighchartsChartHost,
        // HighchartsChartComponent,
        TranslateModule.forChild({
            extend: true,
            loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json?v=' + Date.now() })
        }),
    ],
    exports: [
        EVAAIAgentComponent,
        TranslateModule
    ]
})
export class EVAAIAgentModule { }